import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import applyMiddleware from './redux/applyMiddleware';
import createStore from './redux/createStore';
import mw from './middlewares';
var _Ext$utils = Ext.utils,
    isPlainObject = _Ext$utils.isPlainObject,
    extend = _Ext$utils.extend;
/**
 * 定义可与 QView 绑定的 store
 *
 * @param options {Array} 官方提供的 createStore 参数, 包含 reducer/initialState/enhancer
 * @param middleware {Array} 中间件数组, 我们内置的中间件会放在所有中间件之后
 */

function getStore(options) {
  var middleware = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var finalCreate = applyMiddleware.apply(void 0, _toConsumableArray(middleware).concat(_toConsumableArray(mw)))(createStore);
  return finalCreate.apply(void 0, _toConsumableArray(options));
}

export default function defineStore(state) {
  var _Ext$defaults$redux = Ext.defaults.redux,
      reducer = _Ext$defaults$redux.reducer,
      initialState = _Ext$defaults$redux.initialState,
      enhancer = _Ext$defaults$redux.enhancer,
      middleware = _Ext$defaults$redux.middleware;

  if (state) {
    if (initialState) {
      initialState = Object.assign({}, initialState, state);
    } else {
      initialState = state;
    }
  }

  return getStore([reducer, initialState, enhancer], middleware);
}
;